import styled from 'styled-components';
import { IconButton } from '@mui/material';

export const Wrapper = styled.div`
  margin: 40px;
`;

export const StyledButton = styled(IconButton)`
  color: red;
  bottom: 20px;
`;
